import PropTypes from 'prop-types';
import useAlertTracking from '../hooks/useAlertTracking';

/**
 * Wraps children in alert-display tracking for render prop / HOC patterns
 * where `useAlertTracking` cannot be called directly.
 */
const TrackedAlert = ({
  headline,
  status,
  alertName,
  alertId,
  isVisible,
  context,
  children,
}) => {
  useAlertTracking({
    headline,
    status,
    alertName,
    alertId,
    isVisible,
    context,
  });

  return children;
};

TrackedAlert.propTypes = {
  alertName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  headline: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  alertId: PropTypes.string,
  context: PropTypes.object,
  isVisible: PropTypes.bool,
};

TrackedAlert.defaultProps = {
  isVisible: true,
  context: {},
};

export default TrackedAlert;
